import { getApigeeApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    locationKeyword,
    locationType,
    startDate,
    endDate,
    limit,
    radius,
    sortType,
    destinationcode,
    stateProvince,
    country,
    lob,
  }, action, state) => ({
    url: `${getApigeeApiUrl(state)}/travel/v2/travel_services/xsell/suggestions`,
    opts: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        locationKeyword,
        locationType,
        startDate,
        endDate,
        limit,
        radius,
        sortType,
        destinationcode,
        stateProvince,
        country,
        lob,
      }),
    },
  }),
};
